export default "assets/images/icons/email-d0e759d1.svg";